module.exports = __webpack_public_path__ + "static/media/pos2.bd21e887.png";